import styled from 'styled-components';
import { theme } from '../../../constants/theme.mjs';
"use strict";
const Wrap = styled.div`
  display: inline-block;
  position: relative;
`;
const CartQuantityEllipse = styled.div`
  opacity: ${({
  $show
}) => $show ? 1 : 0};
  position: absolute;
  right: -6px;
  bottom: -6px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 14px;
  height: 14px;
  background: ${theme.colors.primaryBlue};
  border-radius: 14px;
  box-shadow: 0 0 0 1px ${({
  $motif
}) => theme.colors.menu.base[$motif]};
  user-select: none;
  padding: 0 2px;

  /* Text */
  font-weight: bold;
  font-size: ${theme.font.size9};
  line-height: 14px;
  color: ${theme.colors.white};
`;
export { CartQuantityEllipse, Wrap };
//# sourceMappingURL=CartIcon.styles.mjs.map
